// extracted by mini-css-extract-plugin
export var menu = "menu-module--menu--1CvF9";
export var language = "menu-module--language--tbgH0";
export var menuList = "menu-module--menuList--eHChU";
export var active = "menu-module--active--1PlRy";